import React from 'react';

export default function ServiceUserGPModule({ serviceUser, onClose }) {
    const gpData = serviceUser.gpInfo || {};

    const Field = ({ label, value }) => (
        <div style={{ marginBottom: '15px', minWidth: '200px', flex: '1' }}>
            <label style={{ display: 'block', fontSize: '12px', textTransform: 'uppercase', color: '#6b7280', marginBottom: '4px', fontWeight: 'bold' }}>{label}</label>
            <div style={{ fontSize: '15px', fontWeight: '500', color: '#111827' }}>{value || 'Not provided'}</div>
        </div>
    );

    return (
        <div style={styles.modalOverlay} onClick={onClose}>
            <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
                <div style={styles.modalHeader}>
                    <div>
                        <h2 style={{ margin: 0, fontSize: '20px', color: '#111827' }}>General Physician</h2>
                        <p style={{ margin: '4px 0 0', color: '#6b7280', fontSize: '14px' }}>Primary medical contact for {serviceUser.fullName}</p>
                    </div>
                    <button onClick={onClose} style={styles.closeBtn}>×</button>
                </div>
                
                <div style={styles.scrollArea}>
                    <div style={styles.section}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                            <Field label="Practice / GP Name" value={gpData.gpName} />
                            <Field label="Practice Address" value={gpData.gpAddress} />
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginTop: '16px' }}>
                            <Field label="Primary Phone" value={gpData.gpPhone} />
                            <Field label="Emergency Phone" value={gpData.gpEmergencyTel} />
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginTop: '16px' }}>
                            <Field label="Email Address" value={gpData.gpEmail} />
                            <Field label="Website" value={gpData.gpWebsite} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const styles = {
    modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
    modalContent: { backgroundColor: 'white', borderRadius: '12px', width: '90%', maxWidth: '600px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' },
    modalHeader: { padding: '24px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' },
    closeBtn: { background: 'none', border: 'none', fontSize: '24px', color: '#9ca3af', cursor: 'pointer', lineHeight: 1 },
    scrollArea: { padding: '24px', overflowY: 'auto' },
    section: { backgroundColor: '#f9fafb', borderRadius: '8px', padding: '20px', border: '1px solid #e5e7eb' }
};
